module.exports = __webpack_public_path__ + "img/logo.a8fa3159.svg";